<template>
  <div>
    <a-row>
      <a-col :span="24" style="padding:10px">
        <a-form :model="form" :laba-position="'left'" laba-width="100px" ref="form">
          <a-form-item label="List name">
            <a-input v-model="form.name" autocomplete="off"></a-input>
          </a-form-item>
          <a-form-item label="Field">
            <a-select v-model="form.field">
              <a-select-option v-for="field in fields" :key="field" :label="field" :value="field"></a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Conditions" v-if="form.conditions.length">
            <div :key="index" v-for="(input, index) in form.conditions">
              <a-select v-model="form.conditions[index].field" style="width:30%">
                <a-select-option v-for="field in fields" :key="field" :label="field" :value="field"></a-select-option>
              </a-select>&nbsp;contains&nbsp;
              <a-input v-model="form.conditions[index].value" autocomplete="off" style="width:25%"></a-input>
              <a-button @click="deleteCondition(index)">Delete</a-button>
            </div>
          </a-form-item>
          <a-form-item>
            <a-button @click="addCondition">Add condition</a-button>
          </a-form-item>

          <a-form-item label>
            <a-button type="primary" @click="submitForm('form')">Submit</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import * as utils from "@/utils.js";
export default {
  props: ["task_id", "date", "drawer"],
  data() {
    return {
      fields: [],
      form: {
        name: "",
        field: "",
        task_id: this.task_id,
        date: this.date,
        conditions: []
      },
      loading: false
    };
  },
  methods: {
    addCondition() {
      this.form.conditions.push({
        field: "",
        value: ""
      });
    },
    deleteCondition(index) {
      this.form.conditions.splice(index, 1);
    },
    submitForm(formName) {
      //
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log(this.form);

          utils
            .sendPost("/api/upload/list/fromResult", this.form)
            .then(resp => {
              if (resp.error == null) {
                this.drawer.closeDrawer();
              } else {
                alert(resp.error);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  mounted() {
    let that = this;
    fetch(`/api/tasks/${this.task_id}/results/fields/${this.date}/`)
      .then(function(response) {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }
        response.json().then(function(data) {
          if (data.fields != undefined && data.fields.length > 0) {
            that.fields = data.fields;
          }
          /*
          if (data.results) {
            let one = data.results[0].data;
            let jone = JSON.parse(one);
            let keys = Object.keys(jone);
            that.table.total = parseInt(data.total);
            console.log(that.table);
            let titles = [];
            for (var k in keys) {
              that.table.titles = [];
              titles.push({ prop: keys[k], label: keys[k].toUpperCase() });
            }
            that.table.titles = titles;
          }

          let records = [];
          for (var i in data.results) {
            records.push(JSON.parse(data.results[i].data));
          }
          that.table.records = records;
          */
        });
      })
      .catch(function(err) {
        console.log("Fetch Error :-S", err);
      });
    console.log(this.task_id, this.date);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/internal/Res2List.vue